import { useEffect, useState, useRef } from "react";
/*Animated Counter*/
function AnimatedCounter({ end, suffix = "" }) {
  const [count, setCount] = useState(0);
  const counterRef = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting || hasAnimated.current) return;

      hasAnimated.current = true;

      let current = 0;

      const interval = setInterval(() => {
        current++;

        setCount(current);

        if (current >= end) {
          clearInterval(interval);
        }
      }, 60);

      observer.disconnect();
    });

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => observer.disconnect();
  }, [end]);

  return (
    <span ref={counterRef}>
      {count}
      {suffix}
    </span>
  );
}

export default AnimatedCounter;
